export default __webpack_public_path__ + "static/media/header-logo.4f44929c.png";